"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var react_router_1 = require("react-router");
var react_router_dom_1 = require("react-router-dom");
var redux_1 = require("redux");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var Text_1 = __importDefault(require("shared/components/Text"));
var HoCs_1 = require("utils/HoCs");
var hooks_1 = require("utils/hooks");
var CreateCustomerButton_1 = __importDefault(require("./CreateCustomerButton"));
var Customers_1 = __importDefault(require("./Customers"));
var MyCustomersNew = function (_a) {
    var company = _a.company;
    var _b = __read((0, hooks_1.useSubmitter)('companies', company.id, { updatingCustomers: true }), 2), updateCustomers = _b[0], isLoading = _b[1];
    react_1.default.useEffect(function () {
        if (!company.updatingCustomers
            && (!company.customersLastUpdate || (0, date_fns_1.differenceInMinutes)(new Date(), company.customersLastUpdate.toDate()) > 10)) {
            updateCustomers();
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "My Customers", description: "my customers" }), (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ mt: 1, mb: 2, mx: "auto", pb: 4, height: "100%", width: "100%", display: "flex", flexDirection: "column", maxWidth: "1500px" }, { children: [(0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4, width: "calc(100% - 120px)" }, { children: [(0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 1 }, { children: "My Customers" })), (0, jsx_runtime_1.jsx)("div", { children: (isLoading || company.updatingCustomers) && (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ mt: 1, level: "caption" }, { children: [(0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, {}), " Refreshing"] })) }), (0, jsx_runtime_1.jsx)(CreateCustomerButton_1.default, {})] })), (0, jsx_runtime_1.jsxs)(react_router_dom_1.Switch, { children: [(0, jsx_runtime_1.jsx)(react_router_1.Route, { exact: true, path: "/accountant/my-customers", component: Customers_1.default }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Redirect, { exact: true, path: "/accountant", to: "/accountant/my-customers" })] })] }))] }));
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.default.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'name', order: 1 }); })(MyCustomersNew);
